const packages = require('../../package-lock.json').dependencies;
export const variables = {
    version: require('../../package.json').version,
    cupcakeVersion: packages['@ipreo/cupcake'].version,
    kendoStylesVersion: packages['@ipreo/cupcake-kendo-styles'].version,
    cupcakeBranding: packages['@ipreo/cupcake-branding'].version
};
